import { createContext } from "react";
const AutomationContext = createContext();
export default AutomationContext;

